import React from 'react'
import PropTypes from 'prop-types'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import MuiCheckbox from '@material-ui/core/Checkbox'


const Checkbox = ({
  label,
  className,
  labelProps,
  ...props
}) => (
  <FormControlLabel
    label={label}
    className={className}
    control={<MuiCheckbox {...props} color="primary" />}
    {...labelProps}
  />
)


Checkbox.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  labelProps: PropTypes.object,
}


export default Checkbox
